import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { ACRouterButton } from 'academy-common-lib/components/ACRouterButton';
import UsageTracker from '../../utils/UsageTracker';
import { WIZARD_URL_FRAGMENT } from '../../constants/Navigation.legacy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecommendationsResetModal = ({
  onClose
}) => {
  const handleUpdateClick = () => {
    UsageTracker.track('interaction', {
      action: 'catalog-recommendation-reset-modal-update'
    });
  };
  const handleCloseClick = () => {
    UsageTracker.track('interaction', {
      action: 'catalog-recommendation-reset-modal-close'
    });
    onClose();
  };
  return /*#__PURE__*/_jsxs(Modal, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.resetLink.infoModalHeader"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => handleCloseClick()
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.resetLink.infoModalMessage"
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(ACRouterButton, {
        onClick: handleUpdateClick,
        to: WIZARD_URL_FRAGMENT,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.resetLink.infoModalUpdate"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: handleCloseClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.resetLink.infoModalClose"
        })
      })]
    })]
  });
};
export default RecommendationsResetModal;